import { render, staticRenderFns } from "./QuotationCostsCardAgricolaProdutividade.vue?vue&type=template&id=1bc5026a"
import script from "./QuotationCostsCardAgricolaProdutividade.vue?vue&type=script&lang=js"
export * from "./QuotationCostsCardAgricolaProdutividade.vue?vue&type=script&lang=js"
import style0 from "./QuotationCostsCardAgricolaProdutividade.vue?vue&type=style&index=0&id=1bc5026a&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports